import React, { Fragment, useEffect, useState } from 'react';
import { Select, Dropdown, Icon } from 'tea-component';

import './index.scss';
import { transAbbreviation } from '../../utils';
import { useIntl } from 'umi';

export default function CountrySingleSelecter({
  optionsData,
  secondary = false,
  onChange,
  region,
  city,
}: any) {
  // secondary 次级筛选
  let countryOptions: Array<{ text: any; value: string }> = [];

  optionsData.map((item: any) => {
    let countryOption = {
      text: (
        <div className="dbo-select-flex">
          <img className="dbo-select-countryicon" src={item.country_icon} />
          <span>{transAbbreviation(item.country_name, 'region_en')}</span>
        </div>
      ),
      value: item.country_name,
    };

    countryOptions.push(countryOption);
  });

  const [selectedCityList, setSelectedCityList] = useState({
    list: [],
    parent: '',
  });
  const [regionOptions, setRegionOptions] = useState<any>([]);
  const { formatMessage } = useIntl();

  useEffect(() => {
    // 初始化值
    if (secondary) {
      let tempOptions: { value: any; text: JSX.Element; cityList: any }[] = [];
      optionsData.map((item: any) => {
        let regionOption = {
          value: item.country_name,
          text: (
            <>
              <img className="dbo-select-countryicon" src={item.country_icon} />
              <span>{transAbbreviation(item.country_name, 'region_en')}</span>
            </>
          ),
          cityList: item?.city_list || [],
        };

        tempOptions.push(regionOption);
      });

      let item = tempOptions?.[0] || {};
      setRegionOptions(tempOptions);
      setSelectedCityList({ list: item?.cityList || [], parent: item.value });

      if (!region) {
        onChange(
          {
            region: item.value,
            city: item?.cityList?.[0] || '',
          },
          false,
        );
      }
    }
  }, [optionsData]);

  return !secondary ? (
    <Select
      className="dbo-regionselecter select-item"
      size="m"
      listHeight={252}
      matchButtonWidth
      appearance="button"
      value={region}
      onChange={(value) => {
        onChange({ region: value, city: '' });
      }}
      options={countryOptions}
      button={(option) => (
        <div className="select-button">
          <div className="select-button-text">
            {formatMessage({ id: 'Country' })}
          </div>
          {countryOptions.map((item: any) => {
            return (
              <Fragment key={item.value}>
                {item.value == region ? item.text : null}
              </Fragment>
            );
          })}
        </div>
      )}
    />
  ) : (
    <Dropdown
      className="dbo-regionselecter dbo-regionselecter--secondary"
      button={
        <div className="select-button">
          <div className="select-button-text">
            {formatMessage({ id: 'Country' })}
          </div>
          {regionOptions.map((item: any) => {
            return (
              <Fragment key={item.value}>
                {item.value == region ? (
                  <div className="dbo-select-value">
                    {item.text}
                    <span>&nbsp;/ {city}</span>
                  </div>
                ) : null}
              </Fragment>
            );
          })}
        </div>
      }
      appearance="button"
      clickClose={false}
    >
      {(close) => (
        <div className="dbo-regionselecter-content">
          {/* 左侧选择区域 */}
          <div className="dbo-regionselecter-content-wrap">
            <div className="dbo-regionselecter-checkbox tea-list--option">
              {regionOptions.map((item: any) => {
                return (
                  <li
                    key={item.value}
                    className={`dbo-regionselecter-checkitem ${
                      item.value == region ? 'is-selected' : ''
                    }`}
                    onClick={() => {
                      setSelectedCityList({
                        list: item.cityList,
                        parent: item.value,
                      });
                      onChange(
                        { region: item.value, city: item.cityList[0] },
                        false,
                      );
                    }}
                  >
                    <div className="dbo-select-flex">{item.text}</div>
                    <Icon type="arrowright" />
                  </li>
                );
              })}
            </div>
          </div>
          {/* 右侧选择区域 */}
          <div className="dbo-regionselecter-content-wrap">
            <div className="dbo-regionselecter-checkbox dbo-regionselecter-checkbox--secondary tea-list--option">
              {selectedCityList.list.map((item) => {
                return (
                  <li
                    key={item}
                    className={`dbo-regionselecter-checkitem ${
                      item === city ? 'is-selected' : ''
                    }`}
                    onClick={() => {
                      onChange({
                        region: selectedCityList.parent,
                        city: item,
                      });
                      close();
                    }}
                  >
                    <div className="dbo-select-flex">
                      <span>{item}</span>
                    </div>
                  </li>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </Dropdown>
  );
}
